import { setGADataLayer } from 'analytics'

type ChangePasswordEvent = 'error' | 'open' | 'success'

export function trackChangePasswordEvent(event: ChangePasswordEvent, formError?: string) {
    const data = {
        event: `change_password_${event}`,
        options: {
            form: {
                formName: 'change password',
            },
        },
    }

    if (formError) {
        data.options.form['formError'] = formError
    }

    setGADataLayer(data)
}
